export type TAddToCartState = {
    isOpen: boolean;
    isHydrated: boolean;
};

export const $AddToCartModuleName = "addToCart";
